import styled from "styled-components";

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: #F6F6F6;
  color: #7C7C7C;
  height: 40px;
  border: none;
  padding: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
`;

export const CoverWrapper = styled.div`
  display: flex;
  gap: 5px;
`;
